import { ConflictProposalModal } from "./ConflictProposalModal"
export default ConflictProposalModal
